<template>
    <Btn
        :label="text"
        :loading="spinner"
        @click="$emit('click')"
    >
        <template #left>
            <img
                :src="iconSrc"
                :alt="iconAlt"
                class="w-6 h-6"
            />
        </template>
    </Btn>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

/**
 * Button used to display auth providers and visualize their progress.
 * The component extends all props native HTML buttons!
 */
export default defineComponent({
    name: 'BtnAuth',
    props: {
        /**
         * Icon of the auth provider
         */
        iconSrc: {
            type: String,
            required: true,
        },
        /**
         * Icon alt text; name of the auth provider
         */
        iconAlt: {
            type: String,
            required: true,
        },
        /**
         * Additional text to display besides the icon
         */
        text: {
            type: String,
            default: null,
        },
        /**
         * When `true`, a spinner will appear instead of the icon + text
         */
        spinner: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['click'],
});
</script>
